import { useDispatch } from "react-redux";
import useFetch from "../../hooks/useFetch";
import { getSupplierSuccess, start } from "../../store/slices/TeamManagementSlice";

const SupplierGoalDetail = ({ rowDataSupplier }) => {
    function formatDate(dateToString) {
        const date = new Date(dateToString);
        const day = date.getDate();
        const monthIndex = date.getMonth().toString();
        const year = date.getFullYear().toString();

        const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const month = monthNames[monthIndex];

        //let hours = date.getHours();
        //let minutes = date.getMinutes();

        // const ampm = hours >= 12 ? 'PM' : 'AM';
        //hours = hours % 12;
        // hours = hours ? hours : 12;
        // minutes = minutes < 10 ? '0' + minutes : minutes;

        const formattedDate = `${day} ${month} ${year}  `;
        return formattedDate;
    }

    const dispatch = useDispatch();
    const { data } = useFetch('suppliers')
    if (data.results && data.results.length > 0) {
        dispatch(getSupplierSuccess(data));
    } else (
        dispatch(start())
    )

    return (
        <>
            {
                rowDataSupplier && rowDataSupplier.length > 0 ? (
                    rowDataSupplier.map((curData => {
                        const { id, name, user_id, email, address, city, state, zip, country, status, created_at, updated_at, supervisor_id, contact_person_name, department_id, contact, target, completed } = curData;

                        return (
                            <tr key={id}>
                                <td>{name}</td>
                                <td>{formatDate(created_at)}</td>
                                <td>{updated_at}</td>
                                <td>John Doe</td>
                                <td>{completed}%</td>
                                <td>{target}</td>
                                <td>{status ? "Active" : "Inactive"}</td>
                            </tr>
                        )
                    }))) : (
                    <span>No supplier data available.</span>
                )
            }
        </>
    )
}

export default SupplierGoalDetail;